'use client';

import { useState } from 'react';
import OfferBuilderForm from './OfferBuilderForm';
import OfferBuilderResults from './OfferBuilderResults';

export interface OfferData {
  // Step 1: Debtor Information
  debtorName: string;
  debtorAddress: string;
  debtorPhone: string;
  debtorEmail: string;
  
  // Step 2: Judgment Details
  judgmentAmount: string;
  judgmentDate: string;
  caseNumber: string;
  courtName: string;
  interestRate: string;
  currentBalance: string;
  
  // Step 3: Offer Terms
  offerType: 'lump-sum' | 'payment-plan' | 'hybrid';
  offerAmount: string;
  offerPercentage: string;
  settlementReason: string;
  
  // Step 4: Payment Structure (for payment plans)
  downPayment: string;
  monthlyPayment: string;
  numberOfPayments: string;
  paymentStartDate: string;
  
  // Step 5: Terms & Conditions
  expirationDate: string;
  acceptanceDeadline: string;
  additionalTerms: string;
  includeReleaseClause: boolean;
  includeConfidentiality: boolean;
}

export default function OfferBuilderInteractive() {
  const [showResults, setShowResults] = useState(false);
  const [offerData, setOfferData] = useState<OfferData | null>(null);

  const handleFormComplete = (data: OfferData) => {
    setOfferData(data);
    setShowResults(true);
  };

  const handleStartOver = () => {
    setShowResults(false);
    setOfferData(null);
  };

  return (
    <div data-component-id="src/app/settlement-center/offer-builder/components/OfferBuilderInteractive.tsx:57:4" data-component-path="src/app/settlement-center/offer-builder/components/OfferBuilderInteractive.tsx" data-component-line="57" data-component-end-line="63" data-component-file="OfferBuilderInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-4xl%20mx-auto%22%7D" className="max-w-4xl mx-auto">
      {!showResults ? (
        <OfferBuilderForm data-component-id="src/app/settlement-center/offer-builder/components/OfferBuilderInteractive.tsx:59:8" data-component-path="src/app/settlement-center/offer-builder/components/OfferBuilderInteractive.tsx" data-component-line="59" data-component-end-line="59" data-component-file="OfferBuilderInteractive.tsx" data-component-name="OfferBuilderForm" data-component-content="%7B%22elementName%22%3A%22OfferBuilderForm%22%7D" onComplete={handleFormComplete} />
      ) : (
        <OfferBuilderResults data-component-id="src/app/settlement-center/offer-builder/components/OfferBuilderInteractive.tsx:61:8" data-component-path="src/app/settlement-center/offer-builder/components/OfferBuilderInteractive.tsx" data-component-line="61" data-component-end-line="61" data-component-file="OfferBuilderInteractive.tsx" data-component-name="OfferBuilderResults" data-component-content="%7B%22elementName%22%3A%22OfferBuilderResults%22%7D" offerData={offerData!} onStartOver={handleStartOver} />
      )}
    </div>
  );
}